import React from 'react'
import { CNav, CNavItem, CNavLink } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { icon } from '../shared/icons'

function AppTabs({ activeTab, onChange }) {
  return (
    <CNav variant="tabs" role="tablist" className="tab-bar">
      <CNavItem>
        <CNavLink active={activeTab === 'agencies'} onClick={() => onChange('agencies')}>
          <CIcon icon={icon('cilSpeedometer')} /> Agencias
        </CNavLink>
      </CNavItem>
      <CNavItem>
        <CNavLink active={activeTab === 'scripts'} onClick={() => onChange('scripts')}>
          <CIcon icon={icon('cilCode')} /> Scripts
        </CNavLink>
      </CNavItem>
      <CNavItem>
        <CNavLink active={activeTab === 'global-parameters'} onClick={() => onChange('global-parameters')}>
          <CIcon icon={icon('cilSettings')} /> Parametros Globales
        </CNavLink>
      </CNavItem>
      <CNavItem>
        <CNavLink active={activeTab === 'boston-ia'} onClick={() => onChange('boston-ia')}>
          <CIcon icon={icon('cilLightbulb')} /> Boston IA
        </CNavLink>
      </CNavItem>
    </CNav>
  )
}

export default AppTabs
